import { Button, Modal } from 'reactstrap';

interface Props {
  offerId: string;
  isOpen: boolean;
  onToggle: () => void;
  onConfirmation: (offerId: string, hasRentalManagement: boolean) => void;
  onConfirmationWithoutRentalManagement: (
    offerId: string,
    hasRentalManagement: boolean,
  ) => void;
  bodyText: string;
  confirmationText: string;
  confirmationWithoutRMText: string;
  abortText: string;
  titleText: string;
}

export default function CreateContractExpressModal({
  offerId,
  isOpen,
  onToggle,
  onConfirmation,
  onConfirmationWithoutRentalManagement,
  bodyText,
  confirmationText,
  confirmationWithoutRMText,
  abortText,
  titleText,
}: Props) {
  return (
    <Modal
      className="modal-dialog-centered"
      isOpen={isOpen}
      toggle={() => onToggle()}
    >
      <div className="modal-header">
        <h6 className="modal-title" id="modal-title-default">
          {titleText}
        </h6>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => onToggle()}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body">
        <p>{bodyText}</p>
      </div>
      <div className="modal-footer">
        <Button
          color="primary"
          type="button"
          onClick={() => onConfirmation(offerId, true)}
        >
          {confirmationText}
        </Button>
        <Button
          color="warning"
          type="button"
          onClick={() => onConfirmationWithoutRentalManagement(offerId, false)}
        >
          {confirmationWithoutRMText}
        </Button>
        {/* <Button
          className="ml-auto"
          color="link"
          data-dismiss="modal"
          type="button"
          onClick={() => onToggle()}
        >
          {abortText}
        </Button> */}
      </div>
    </Modal>
  );
}
